<script lang="ts" setup>
import { computed } from 'vue';
import type { Props } from './types';
import { dateFormat } from '@/core/utils/date';

const props = withDefaults(defineProps<Props>(), {
	size: 64,
	i18n: () => ({
		Online: 'Online',
		LastSeen: 'Last seen',
	}),
});

const titleStatus = computed(() => {
	if (props.isOnline) {
		return props.i18n?.Online;
	}

	if (props.lastActiveTime) {
		return props.i18n?.LastSeen + ': ' + dateFormat(props.lastActiveTime, 2);
	}
});

const titleImage = computed(() => {
	if (!props.nickname) return titleStatus.value;

	return props.nickname + (titleStatus.value ? `\n${titleStatus.value}` : '');
});
</script>

<template>
	<div class="top-avatar">
		<img
			class="top-avatar_image"
			:src="image"
			:title="titleImage"
			alt=""
		>

		<div
			v-if="isOnline"
			class="top-avatar_status"
			:title="titleStatus"
		>
		</div>
	</div>
</template>

<style>
.top-avatar {
	width: v-bind(size+ "px");
	height: v-bind(size+ "px");
	display: flex;
	flex-grow: 0;
	flex-shrink: 0;
	position: relative;
	top: 0;
	left: 0;
}

.top-avatar_image {
	border-radius: 50%;
	width: 100%;
	height: 100%;
}

.top-avatar_status {
	border-radius: 50%;
	border: 2px solid var(--color-layout-front-1);
	background-color: var(--color-bg-positive-1);
	width: 25%;
	height: 25%;
	position: absolute;
	right: 0;
	bottom: 0;
}
</style>
